<div class="flex h-screen">
    <div class="flex flex-col flex-1 overflow-hidden transition-all duration-200 ease-in-out">
        <div class="flex items-center justify-between border-b px-6 py-4 ">
            <div class="flex items-center gap-2">
                <p-skeleton width="24rem" height="1.5rem"></p-skeleton>
            </div>

            <div class="flex items-center gap-2">
                <p-skeleton width="1.25rem" height="1.25rem" class="rounded-full"></p-skeleton>
                <p-skeleton width="1.25rem" height="1.25rem" class="rounded-full"></p-skeleton>
                <p-skeleton width="1.25rem" height="1.25rem" class="rounded-full"></p-skeleton>
                <p-skeleton width="1.25rem" height="1.25rem" class="rounded-full"></p-skeleton>

            </div>
        </div>
        <!-- Skeleton Chat Messages -->
        <div class="flex-1 overflow-y-auto px-6 py-4 pb-[5.5rem]">
            <div class="mx-auto max-w-3xl space-y-6">
                <!-- Generate multiple message skeletons based on messageCount -->
                @for (index of getMessageArray(); track index) {
                @if (index % 2 === 0) {
                <!-- User message - every other message -->
                <div class="flex justify-end transition-opacity duration-700" [style.opacity]="1 - (index * 0.10)">
                    <div class="max-w-[85%] rounded-lg bg-gray-100/50 px-4 py-3">
                        <div class="space-y-2">
                            <p-skeleton width="12rem" height="1rem"></p-skeleton>
                            <p-skeleton width="8rem" height="1rem"></p-skeleton>
                        </div>
                    </div>
                </div>
                } @else {
                <!-- Assistant response with tool usage -->
                <div class="transition-opacity duration-700" [style.opacity]="1 - (index * 0.15)">
                    <div class="flex items-start gap-3">
                        <p-skeleton width="1.25rem" height="1.25rem"
                            class="flex-shrink-0 mt-2 rounded-full"></p-skeleton>
                        <div class="flex-1 space-y-2 bg-gray-100/50 rounded-lg px-4 py-3 max-w-[90%]">
                            <div class="max-w-[90%] w-full rounded-lg bg-muted px-4 py-3">
                                <div class="space-y-3">
                                    <div>
                                        <p-skeleton width="100%" height="1rem" [style.max-width]="'360px'"
                                            class="mb-2"></p-skeleton>
                                        <p-skeleton width="100%" height="1rem" [style.max-width]="'320px'"
                                            class="mb-2"></p-skeleton>
                                        <p-skeleton width="100%" height="1rem" [style.max-width]="'290px'"></p-skeleton>
                                    </div>
                                    <!-- Tool call button skeleton -->
                                    @if (index % 3 === 1) {
                                    <div class="py-1">
                                        <p-skeleton width="8rem" height="1.5rem" class="rounded-md"></p-skeleton>
                                    </div>
                                    }
                                    @if (index % 3 === 1) {
                                    <div>
                                        <p-skeleton width="100%" height="1rem" [style.max-width]="'340px'"
                                            class="mb-2"></p-skeleton>
                                        <p-skeleton width="100%" height="1rem" [style.max-width]="'280px'"></p-skeleton>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
                }

                <!-- Assistant thinking state -->
                <div>
                    <div class="flex items-center gap-3 opacity-15">
                        <p-skeleton width="1.25rem" height="1.25rem"
                            class="flex-shrink-0 mt-2 rounded-full"></p-skeleton>
                        <div class="flex-1 space-y-2">
                            <div class="flex items-center gap-1.5 py-1">
                                <div class="h-1.5 w-1.5 rounded-full bg-gray-400/50 animate-pulse"></div>
                                <div class="h-1.5 w-1.5 rounded-full bg-gray-400/50 animate-pulse"
                                    style="animation-delay: 150ms"></div>
                                <div class="h-1.5 w-1.5 rounded-full bg-gray-400/50 animate-pulse"
                                    style="animation-delay: 300ms"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Skeleton Side Panel (closed state) -->
    @if (isSidePanelOpen()) {
    <div class="hidden sm:block">
        <div class="h-screen w-[450px] border-l">
            <div class="p-4">
                <p-skeleton width="8rem" height="2rem" class="mb-4"></p-skeleton>
                <p-skeleton width="100%" height="5rem" class="rounded-md mb-4"></p-skeleton>
                <p-skeleton width="100%" height="10rem" class="rounded-md"></p-skeleton>
            </div>
        </div>
    </div>
    }
</div>
